import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Modal from '@components/Modal/Modal';
import useRiskLevelById from '@store/hooks/useRiskLevelById';
import useRiskLevels from '@store/hooks/useRiskLevels';

import RiskLevelModalTab from './RiskLevelModalTab/RiskLevelModalTab';
import { IRiskLevelModalProps } from './RiskLevelModal.interface';

import './style.scss';

const RiskLevelModal: FC<IRiskLevelModalProps> = ({ open, onClose, defaultRiskLevel }) => {
  const { t } = useTranslation();

  const [activeRiskLevel, setActiveRiskLevel] = useState(defaultRiskLevel);
  useEffect(() => setActiveRiskLevel(defaultRiskLevel), [defaultRiskLevel]);

  const riskLevels = useRiskLevels();
  const riskLevel = useRiskLevelById(activeRiskLevel);

  if (!riskLevel) return null;

  return (
    <Modal
      onClose={onClose}
      open={open}
      title={t('riskLevels.title')}
      className="risk-level-modal"
      showCloseButton
    >
      <div className="risk-level-modal__top-hint">{t('riskLevels.topHint')}</div>

      <div className="risk-level-modal__tabs">
        {riskLevels.map(item => (
          <RiskLevelModalTab
            riskLevel={item}
            isActive={item.riskLevelId === activeRiskLevel}
            onClick={setActiveRiskLevel}
            key={item.id}
          />
        ))}
      </div>

      <div className="risk-level-modal__panel">
        <div className="risk-level-modal__name">{riskLevel.longName}</div>
        <div className="risk-level-modal__description">{riskLevel.description}</div>
      </div>
    </Modal>
  );
};

export default RiskLevelModal;
